import { getAdditionalPermissionInputs } from "@modules/backstage/users"
import { TYPE_NONE, TYPE_ROLE, TYPE_HIDDEN } from "@components/Form"


const getUpdateInputs = (isConsoleOrganization, updateSchema, organizationName, isLiaison, isController) => {
  const additionalPermissionInputs = isConsoleOrganization
    ? []
    : getAdditionalPermissionInputs(organizationName, isLiaison, isController)

  const rolesProps = isConsoleOrganization
    ? {
        name: "roles",
        type: TYPE_NONE,
      }
    : {
        name: "roles",
        type: TYPE_ROLE,
        label: "Select Role",
        inputProps: {
          onChange: () => updateSchema(),
          disabled: isController,
        }
      }

  return [
    rolesProps,
    ...additionalPermissionInputs,
    {
      name: "givenName",
      label: "First Name",
      itemProps: { style: { width: 270 } },
    },
    {
      name: "familyName",
      label: "Last Name",
      itemProps: { style: { width: 270 } },
    },
    {
      name: "email",
      itemProps: { style: { width: 270 } },
      inputProps: { disabled: true },
    },
    {
      name: "mobile",
    },
    {
      name: "sponsorId",
      type: TYPE_HIDDEN,
    },
    {
      name: "isDisabled",
      type: TYPE_NONE,
    },
    {
      name: "disabledReason",
      type: TYPE_NONE,
    },
    {
      name: "isMobileVerified",
      type: TYPE_NONE,
    },
    {
      name: "lastAuthenticatedAt",
      type: TYPE_NONE,
    },
  ]
}

export default getUpdateInputs
